import { useMemo } from "react";
import { computePeaks } from "@/components/daw/MicroWaveform";

export const fmtTime = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`;

export function LevelMeter({ level }) {
  const pct = Math.min(100, Math.round(level * 130));
  const hot = level > 0.95;
  return (
    <div data-testid="record-level" data-hot={hot ? "1" : "0"} className="h-2.5 w-full overflow-hidden rounded-full bg-white/[0.08]">
      <div className={`h-full rounded-full transition-[width] duration-100 ${hot ? "bg-red-500" : "bg-gradient-to-r from-emerald-400 via-lime-300 to-amber-400"}`} style={{ width: `${pct}%` }} />
    </div>
  );
}

export function TakeWave({ buffer }) {
  const peaks = useMemo(() => computePeaks(buffer, 120), [buffer]);
  return (
    <div data-testid="take-waveform" className="flex h-16 items-center gap-[2px] rounded-xl bg-black/30 px-2">
      {peaks.map((p, i) => <span key={i} className="flex-1 rounded-full bg-gradient-to-t from-rose-500 to-amber-300" style={{ height: `${Math.max(6, p * 100)}%` }} />)}
    </div>
  );
}
